import Cookie from 'universal-cookie';
import { getCookieExpirationByYears } from '../utils/cookies';
import { DO_NOT_TRANSLATE_BY_DEFAULT_COOKIE_NAME, DEFAULT_MT_COOKIE_DOMAIN } from './constants';

const getDefaultTranslationCookieOptions = () => ({
    expires: getCookieExpirationByYears(2),
    domain: DEFAULT_MT_COOKIE_DOMAIN,
    path: '/',
});

/**
 * Toggle Default MT experience. relevant only for CSR
 * we use cookie to persist it
 * @param {boolean} value :
 *  true means that we want default translation experience so we delete the cookie
 *  false means that we don't want default translation experience and we add the cookie
 */
export const toggleDefaultTranslationExperience = (value: boolean) => {
    if (value) {
        new Cookie().remove(DO_NOT_TRANSLATE_BY_DEFAULT_COOKIE_NAME, getDefaultTranslationCookieOptions());
    } else {
        new Cookie().set(DO_NOT_TRANSLATE_BY_DEFAULT_COOKIE_NAME, true, getDefaultTranslationCookieOptions());
    }
};

/**
 * returns the Default MT cookie
 * @param {object} cookies optional param that represents the cookies object, send it only for SSR scenario
 * @returns {bool} the Default MT value, return false if cookie doesn't exist
 */
export const getDefaultTranslationExperience = (cookies?): boolean => {
    if (cookies) {
        return !cookies[DO_NOT_TRANSLATE_BY_DEFAULT_COOKIE_NAME];
    } else {
        return !new Cookie().get(DO_NOT_TRANSLATE_BY_DEFAULT_COOKIE_NAME);
    }
};

export default {
    toggleDefaultTranslationExperience,
    getDefaultTranslationExperience,
};
